import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { fetchNavigation, fetchWebAPIServerDataHandler } from '@/lib/fetcher';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';
import CruiseIndex from '@/features/cruise/CruiseIndex';
// Import Swiper styles
import 'swiper/css';

import HeadMetaTag2 from '@/components/metatags/HeadMetaTag2';

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const path = '/cruise/home';
  const [navigation, pageProps] = await Promise.all([
    fetchNavigation(),
    fetchWebAPIServerDataHandler(path, 'CRUISE HOME INDEX', req),
  ]);

  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation } };

  return {
    props: {
      data: null,
    },
  };
};

const Page = ({ error, data, ...props }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (error) {
    return <CustomError error={error} />;
  }

  const meta = data.page.meta;

  return (
    <AppProvider navigation={...props.navigation}>
      <HeadMetaTag2 meta={meta as MetaType} />
      <CruiseIndex data={data as CruiseHomeDataType} /> {/*TODO: FIX DATA TYPE*/}
    </AppProvider>
  );
};

export default Page;
